import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=3f1505d2&scoped=true&"
import script from "./transfer.vue?vue&type=script&lang=js&"
export * from "./transfer.vue?vue&type=script&lang=js&"
import style0 from "./transfer.vue?vue&type=style&index=0&id=3f1505d2&lang=less&scoped=true&"
import style1 from "./transfer.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1505d2",
  null
  
)

export default component.exports